import { render } from "./UnitEditor.vue?vue&type=template&id=615b0a8b&scoped=true"
import script from "./UnitEditor.vue?vue&type=script&lang=js"
export * from "./UnitEditor.vue?vue&type=script&lang=js"

import "./UnitEditor.vue?vue&type=style&index=0&id=615b0a8b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\86198\\WebstormProjects\\rustedcreateronline\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615b0a8b"]])

export default __exports__